import React from 'react'

const Spinner = ({ id }) => {
    return (
        <div id={id || "mocklist-spinner"}>
            <div className="spinner-border" role="status">
                <span className="sr-only"></span>
            </div>
        </div>
    )
}

export default Spinner